import { render, staticRenderFns } from "./tax-overview.vue?vue&type=template&id=de77ee9e&"
import script from "./tax-overview.vue?vue&type=script&lang=js&"
export * from "./tax-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports